import { Account } from "@rentablo/api/apiv1";

export const getRedirectType = (val: Account): "depots" | "accounts" => {
  if (
    val.typeFromBank === "CREDIT_CARD" ||
    val.type === "02_cash" ||
    val.type === "04_insurance"
  ) {
    return "accounts";
  }
  if (val.type === "01_depot" || val.type === "05_material_assets") {
    return "depots";
  }

  return "depots";
};
